export default class IHPlaceList {
  
  static extended(core) {
    
    $(core).on('ready', () => {
      
      core.initList();
  
      $.getJSON('./places/count', (res) => {
        if (res && res.count > core.moveListThreshold) {
          core.initPlaceList();
        }else{
          core.initMoveList();
        }
      });
      
    });
  
    $(core).on('ihSelectPlaceFromList', (event, address) => {
      //core.clearFacilitySelector();
      core.controller.clearAllSelector();
    });
    
  }
  
  initList(){
    this.moveListThreshold = 300;
    this.moveListSelector = '.js-move-list';
    this.moveListKanaClass = 'js-move-list-kana';
    this.moveListTemplateClass = 'js-template';
    this.moveListLinkSelector = '.js-move-link';
    this.moveListNameSelector = '.js-move-name';
    this.moveListAreaSelector = '.js-move-area';
    this.moveListTypeSelector = '.js-move-type';
    this.moveListCounterSelector = '.js-move-list-counter';
    this.placeListSearchSelector = '.js-place-list-search';
  }
  
  initPlaceList() {
    
    let ua = window.navigator.userAgent.toLowerCase();
    let old = null;
    let xhr = null;
    let timer = null;
    let that = this;
    
    $(that.moveListSelector).listview({});
    $(that.placeListSearchSelector).on('keyup', function(e) {
      
      let input = $(this);
      let val1 = input.val();
      
      if (e.keyCode === 13 && ua.match(/iphone|ipad|ipod|android/)) {
        $(this).blur();
      }
      if (val1 === '') {
        that.clearMoveList();
        return;
      }
      if (old === val1) {
        return;
      }
      if (xhr && xhr.readyState !== 4) {
        xhr.abort();
      }
      
      old = val1;
      xhr = that.searchPlaceList(val1);
    
      clearTimeout(timer);
      
      timer = setInterval(() => {
        let val2 = input.val();
        if (old === val2) {
          return;
        }
        old = val2;
        xhr = that.searchPlaceList(val2);
      }, 2000);
      
    });
    
  }
  
  initMoveList() {
  
    let that = this;
    $(that.moveListSelector).listview({ filter: true });
    $(that.placeListSearchSelector).closest('div.ui-input-text').hide();
  
    let types = {};
    _.each(that.placeTypes, (type) => {
      if (type.kana_search) {
        types[type.id] = true;
      }
    });
  
    $.getJSON('./places', (res) => {
      let arr = [];
    
      // object to array
      _.each(res, (place) => {
        if (types[place.type]) {
          arr.push(place);
        }
      });
    
      that.renderMoveList(arr);
      
    });
    
  }
  
  searchPlaceList(val){
    
    let that = this;
    
    that.displayLoading(true);
    
    return $.ajax({
      url: './search/keyword/' + val,
      dataType: 'json'
    })
    .always(() => {
      that.displayLoading(false);
    })
    .done(function(res){
      
      let data = [];
      
      // object to array
      for (let i in res){
        if (res.hasOwnProperty(i)) {
          data.push(res[i]);
        }
      }
      
      that.clearMoveList();
      
      $(that.moveListSelector).each(function(){
        let listview = $(this);
        that.renderMoveList(data);
        that.refreshMoveListCounter();
      });
    
    });
  }
  
  clearMoveList(){
    let that = this;
    $(that.moveListSelector).children().not('.'+that.moveListTemplateClass).not('.ui-li-divider').remove();
    $(that.moveListSelector).listview('refresh');
    that.refreshMoveListCounter();
  }
  
  renderMoveList(data){
    
    data = data.sort(this.moveListComparator);
    
    let that = this;
    let listview = $(that.moveListSelector);
    let tpl = listview.find('.' + that.moveListTemplateClass);
    
    let eachList = (i, address) => {
      
      let t = tpl.clone().removeClass(that.moveListTemplateClass);
      let name = address.name;
      let kana = address.kana || "";
      let area = address.area || "";
      let type = address.type_label || "";
      let kanaSpan = $('<span class="'+that.moveListKanaClass+'"></span>').text(kana);
      
      area = area.replace(/^\-$/, '');
      
      t.find(that.moveListTypeSelector).text(type);
      t.find(that.moveListNameSelector).text(name);
      t.find(that.moveListAreaSelector).text(area);
      
      t.find(that.moveListLinkSelector).before(kanaSpan)
      .on('click', () => {
        that.putMarkerAndFocus(address);
        $(that).trigger('ihSelectPlaceFromList', address);
      });
      
      listview.append(t);
      
    };
    
    $.each(data, eachList);
    
    listview.listview('refresh');
    listview.find('.' + that.moveListKanaClass).hide();
    
    this.initMoveListCounter(listview);
    
  }
  
  initMoveListCounter(listview){
    let that = this;
    let input = listview.closest('.ui-panel').find('.ui-listview-filter input');
    input.on('keyup', () => {
      that.refreshMoveListCounter(listview);
    });
    input.trigger('keyup');
  }
  
  moveListComparator(a, b){
    
    let ak, bk;
    
    if (!a.kana && !b.kana) {
      ak = a.name.substr(0);
      bk = b.name.substr(0);
    } else {
      ak = a.kana.substr(0);
      bk = b.kana.substr(0);
    }
    
    if (ak > bk) {
      return 1;
    } else if (ak < bk) {
      return -1;
    } else {
      return 0;
    }
  }
  
  /**
   * 施設１つのマーカーを配置し、フォーカスする
   *
   * @param {Object} address
   */
  putMarkerAndFocus(address){
   
    let that = this;
    
    if (address.lat === '' && address.lng === '' && address.name !== '') {
      let df = that.searchFromAddress(address.name);
      df.always(() => {});
    } else {
      
      that.moveMap(address.lat, address.lng, false);
      
      if (address.id) {
        that.requestPlaces({places: [address.id]})
        .then((res) => {
          let places = res.places;
          that.focusMarker(address.id);
        });
      }
    }
  }
  
  refreshMoveListCounter(){
    let that = this;
    let listview = $(that.moveListSelector);
    let counter = $(that.moveListCounterSelector);
    counter.text(listview.find('li:visible').not('.ui-li-divider').length);
  }
  
}


// WEBPACK FOOTER //
// ./map/js/ih/modules/IHPlaceList.js